import { all, call, spawn } from 'redux-saga/effects';
import { Services } from '../store';
import makeRequest from './makeRequest';

export default (services: Services) =>
    function* rootSaga() {
        const sagas = [makeRequest(services.dataProvider, services.authProvider)];

        yield all(
            sagas.map((saga, index: number) =>
                spawn(function* () {
                    while (true) {
                        try {
                            // @ts-ignore
                            yield call(saga);
                            break;
                        } catch (e) {
                            console.log('Index in saga ', index);
                            console.log('RootSaga error ', e);
                        }
                    }
                })
            )
        );
    };
